import React, { useEffect, useState } from "react";
import axios from "axios";
import FileDownload from "js-file-download";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getCompanyProfileById = async (token: any, userId?: number) => {
  try {
    const config = token
      ? {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      : {};
    let res = null
    if (userId) {
      res = await axios.get(
        `${API_BASE_URL}/api/Users/ComapanyProfile/${userId}/Details`,
        config
      );
    } else {
      res = await axios.get(
        `${API_BASE_URL}/api/Users/ComapanyProfile/Details`,
        config
      );
    }

    return res.data.data;
  } catch (error) {
    return error;
  }
};
